import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'componentClasses'
})
export class ComponentClassesPipe implements PipeTransform {

  transform(component): string[] {
    return component?.componentConfig?.styles?.map(style => style.cssClass) || [];
  }

}
